import { useParams, useNavigate } from 'react-router-dom';
import { usePlayer } from '../hooks/usePlayer';
import ChannelPlayer from '../components/ChannelPlayer';
import PlayerLoading from '../components/PlayerLoading';

export default function ChannelPlayerPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const { loading, channel, playlist, error } = usePlayer(slug);

  if (loading) {
    return <PlayerLoading />;
  }

  if (error || !channel) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-neutral-950 gap-6">
        <div className="w-20 h-20 rounded-full bg-neutral-800 flex items-center justify-center">
          <i className="ri-error-warning-line text-3xl text-neutral-400" />
        </div>
        <h1 className="text-white text-xl font-semibold">Channel not found</h1>
        <p className="text-neutral-400 text-sm">
          The channel you are looking for does not exist.
        </p>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="px-6 py-2.5 rounded-full bg-white text-neutral-900 font-semibold text-sm hover:bg-neutral-200 transition-colors cursor-pointer whitespace-nowrap"
        >
          Back
        </button>
      </div>
    );
  }

  return <ChannelPlayer channel={channel} playlist={playlist} />;
}